import { render, staticRenderFns } from "./headerMessageLocation.vue?vue&type=template&id=1b4beb31"
import script from "./headerMessageLocation.vue?vue&type=script&lang=js"
export * from "./headerMessageLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports